/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ enabled: NonNullable<unknown>, max: NonNullable<unknown> }} Integrations_Usage_Counter_AriaInputs */



/**
* | output |
* | --- |
* | "{enabled} of {max} integrations enabled" |
*
* @param {Integrations_Usage_Counter_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_usage_counter_aria = /** @type {((inputs: Integrations_Usage_Counter_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Usage_Counter_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.enabled} von ${i?.max} Integrationen aktiviert`)
	return /** @type {LocalizedString} */ (`${i?.enabled} of ${i?.max} integrations enabled`)
});